import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import { selectMaintenanceGuides } from '../../store/selectors/faqsNotesDocuments';
import  MaintenanceGuides from '../../components/MaintenanceGuides';
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments,updateFaqsNotesDocuments,deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch,clearSearch } from '../../store/actions/search';

class AssetMaintainenceGuide extends Component {
  componentDidMount(){
      const { clearSearch,onFetchFaqsNotesDocuments,asset} = this.props;
    clearSearch()
    // onFetchFaqsNotesDocuments(asset.item.id);
    
  }

  onSaveMaintenanceGuide = maintenanceguide => {
    const {  onSaveFaqsNotesDocuments,onUpdateFaqsNotesDocuments, user  } = this.props;
    let utcTime = ''
    let defaultDate= new Date();

    if(maintenanceguide.appointment){

   
    let date = new Date(maintenanceguide.appointment.date);
    let time = new Date(maintenanceguide.appointment.time)
    let hours = time.getHours();
    let minutes =time.getMinutes();
    date.setHours(hours);
    date.setMinutes(minutes)
    // utcTime = date.toUTCString()
      utcTime = date
  }


    if(maintenanceguide.id){
      let data = {
        ItemId: this.props.asset.id,
        "id": maintenanceguide.id,
        Name: 'MAINTENANCEGUIDE',
        Type: 'MAINTENANCEGUIDE',
        "data": JSON.stringify(maintenanceguide).toString(),
        "UserId": user.id,
        // "ReminderDate":utcTime,
        MaintenanceReminderFrom:'Asset',
        IsSuiteWarrantyStartDate:maintenanceguide?.IsSuiteWarrantyStartDate,
        Time:maintenanceguide?.appointment?.time

      }
      if(maintenanceguide.appointment){
        data = {...data, ReminderDate: maintenanceguide?.IsSuiteWarrantyStartDate === false ? utcTime :defaultDate, 
          repeatType: maintenanceguide.repeatType ? maintenanceguide.repeatType : '', 
          toggle: maintenanceguide.toggle};
          if(maintenanceguide.repeatType === 'Custom') {
            data = {...data, repeatEvery: Number(maintenanceguide.repeatEvery), repeatTypeEvery: maintenanceguide.repeatTypeEvery}
          }
      }
      onUpdateFaqsNotesDocuments(data)

    }else{
      maintenanceguide = { ...maintenanceguide,'author':{
        "id": this.props.user.id,
        "firstName": this.props.user.firstname,
        "lastName": this.props.user.lastname
      },'createdAt': new Date()}
      let data = {
        ItemId: this.props.asset.id,
        Name: ' MAINTENANCEGUIDE',
        Type: 'MAINTENANCEGUIDE',
        Data: JSON.stringify(maintenanceguide).toString(),
        UserId: user.id,
        // "ReminderDate":utcTime,
        MaintenanceReminderFrom:'Asset',
        IsSuiteWarrantyStartDate:maintenanceguide?.IsSuiteWarrantyStartDate,
        Time:maintenanceguide?.appointment?.time
      }
      if(maintenanceguide.appointment){
        data = {...data, ReminderDate: maintenanceguide?.IsSuiteWarrantyStartDate === false ? utcTime :defaultDate, 
          repeatType: maintenanceguide.repeatType ? maintenanceguide.repeatType : '', 
          toggle: maintenanceguide.toggle};
          if(maintenanceguide.repeatType === 'Custom') {
            data = {...data, repeatEvery: Number(maintenanceguide.repeatEvery), repeatTypeEvery: maintenanceguide.repeatTypeEvery}
          }
      }
      onSaveFaqsNotesDocuments(data)
    }
  }

  render() {
    const ROLES_PERMITTED_TO_ADD_MANTAINACE_REMINDER = new Set(['Super Admin','Admin','Property Developer'])
    const { maintenanceguides, asset,onDeleteFaqsNotesDocuments,setSearch,user } = this.props;
    const { roles } = user;
    return (
      <MaintenanceGuides
        from = "Asset"
        breadcrumb={asset.item.name+" in "+asset.roomType}
        maintenanceguides={maintenanceguides}
        onlyView={!roles.find((role) => ROLES_PERMITTED_TO_ADD_MANTAINACE_REMINDER.has(role.role.name))}
        onSaveMaintenanceGuide={this.onSaveMaintenanceGuide}
        onDeleteNote={  maintenanceguides => onDeleteFaqsNotesDocuments({...maintenanceguides,Type:'MAINTENANCEGUIDE'})}
        onSearch={e => setSearch({  maintenanceguide: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  maintenanceguides: selectMaintenanceGuides(state),
  user: selectAuthenticatedUser(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments:updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments:deleteFaqsNotesDocuments,
  setSearch,
  clearSearch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssetMaintainenceGuide);
